import { render } from "./product-module.vue?vue&type=template&id=6700368d"
import script from "./product-module.vue?vue&type=script&lang=js"
export * from "./product-module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__